import { PRODUCTION_DATASETS } from "./platform";

const dataset = process.env.SANITY_STUDIO_API_DATASET;
const isDevelopment = process.env.NODE_ENV === "development";
export const isProductionDataset = !!dataset && PRODUCTION_DATASETS.includes(dataset);
export const isProduction = !isDevelopment && isProductionDataset;
export const isStagingEnvironment = dataset?.trim().startsWith("e2e-");
